<template>
    <div>
      <el-dialog :title="title" :visible="productVisibleProp" width="70%" @close="onClose">
          <el-form label-width="110px" :inline="true" size="mini">
                   <el-form-item size="mini" label="关键字" prop="keywords">
                       <el-input v-model="keywords" placeholder="请输入产品方案名称"/>
                   </el-form-item>
                  <el-button @click="chooseCar" size="mini">查询</el-button>
           </el-form>
          <div>
              <el-table
                      ref="multipleTable"
                      :data="mList"
                      height="300"
                      stripe
                      border
                      size="mini"
                      :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
              >
                  <el-table-column label="" width="50" align="center">
                      <template slot-scope="scope">
                          <el-radio v-model="currM" :label="scope.row" @input="clickChange(scope.row)">{{ "" }}</el-radio>
                      </template>
                  </el-table-column>
                  <el-table-column
                          label="产品方案名称"
                          width="105"
                          prop="title"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="保司"
                          width="120"
                          prop="corp.name"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="价格"
                          width="130"
                          prop="price"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="产品名称"
                          width="110"
                          prop="product.name"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>

              </el-table>
              <el-row>
                  <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                      <el-button size="mini" @click="close">取消</el-button>
                      <el-button  size="mini" type="primary" @click="ok">确定</el-button>
                  </el-col>
              </el-row>
          </div>
      </el-dialog>
    </div>
</template>
<script>
  export default {
     name:'eProduct',
     props:{
         productVisibleProp:{
             type:Boolean,
             default:false
         }
     },
     data(){
       return {
           keywords:'',
           product_md_name:'',

           product_md_id:'',
           corp_name:'',
           product_name:'',
           currM:'',
           mList:[],
           total:0,
           title:'产品方案选择',
           plate_number:'',
           car_id:'',
           vehicle_type:'',
           allPerson:'',
           vin:'',
           shop_id:'',
           fileList:[],
       }
     },
      created() {
         this.getProductList();
      },
      methods:{
          clickChange(row){
              this.product_md_name=row.title;
              this.product_md_id=row.id;
              this.corp_name=row.corp.name;
              this.product_name=row.product.name;
              this.vin=row.vin;
              this.shop_id=row.shop_id;

          },
          getProductList(){
            const param = {
                company_id:159,
                access_token:sessionStorage.getItem('token'),
            }
            this.$axios.insuranceProductMdList(param).then(res=>{
                if(res.code == 200){
                    this.mList = res.data.data
                    this.total = res.data.total
                }
            }).catch(error=>{
                //console.log(error);
            })
        },
        onClose(){
             this.$emit('update:productVisibleProp',false)
        },
         close(){
             this.$emit('update:productVisibleProp',false)
         },
        ok(){
            this.$emit('eventProduct',this.product_md_name,this.product_md_id,this.corp_name,this.product_name,this.vin,this.shop_id);
            this.$emit('update:productVisibleProp',false)
        },
        handleBeforeUpload(){

        },
        uploadSuccess(){

        },
        uploadFile(){

        },
       chooseCar(){
         this.$emit('eventProduct',this.product_md_name,this.product_md_id);
       }
    }
  }
</script>
<style lang="less" scoped>
    //https://www.yzktw.com.cn/post/1262748.html
    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

    .upload_list {
        width: 120px;
        margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
        font-size: 10px;
        color: #409EFF;
    }

    /deep/.el-icon-upload:before {
        width: 40px !important;
        height: 40px !important;
    }

    .upload_list:last-child {
        margin-right: 0;
    }

    /deep/.el-upload-dragger {
        width: 100%;
        height: auto;
        padding: 20px 0;
        border: 1px solid #999;
    }

    /deep/.el-upload {
        width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
        margin: 10px 0;
    }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/common/eProduct.vue